<script setup lang="ts">
import type { ProfilPreviewFormItemProps } from "@/components/modal/Profile/previewProfile/types";

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = defineProps<ProfilPreviewFormItemProps>();
</script>

<template>
    <div class="profil-preview-form-item">
        <div class="profil-preview-form-item__label">
            <i :class="`profil-preview-form-item__label-icon ti ti-${icon}`" />
            <span class="profil-preview-form-item__label-text typo-xxs-medium">
                {{ label }}
            </span>
        </div>
        <slot />
    </div>
</template>

<style scoped lang="scss">
.profil-preview-form-item {
    display: flex;
    align-items: center;

    &__label {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: var(--spacing-sm, 6px);
        width: 124px;
        color: var(--text-sub-600, #494e61);

        &-icon {
            color: var(--icon-sub-500, #636778);
        }
    }
}
</style>
